import Vue from 'vue'
import App from './App'
import router from './router'
//import 'bootstrap'
import 'bootstrap/dist/js/bootstrap.bundle'
import 'bootstrap/dist/css/bootstrap.min.css'
import './icons'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import store from './store/store'

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js